import styled from '@emotion/styled'
import type { FC } from 'react'

import Divider from '@segment/matcha/components/Divider'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const ResourcesDivider: FC = () => {
  return (
    <StyledSectionBase variant="noCopy">
      <Section.Contents>
        <Divider />
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 0;
    padding-bottom: 0;
  }
`

export default ResourcesDivider
